// extracted by mini-css-extract-plugin
export default {"footer-layout":"footer_footer-layout__WJEuP"};